// /programs/draft — 입찰제안서 빌더.
//
// This is the Claude Design prototype (제안서 빌더.dc.html) served verbatim as a
// self-contained static app under /draft/ (x-dc runtime + vendored React 18 UMD).
// We embed it full-bleed in an iframe, the same pattern EmbedView uses for /bid/.
// The app persists everything to its own localStorage — no backend wiring needed.
export default function DraftPage() {
  return (
    <iframe
      title="입찰제안서 빌더"
      // ?v cache-buster — bump when redeploying the embedded prototype so browsers
      // escape any heuristically-cached copy of /draft/index.html.
      src="/draft/index.html?v=2026062601"
      style={{ flex: 1, width: "100%", height: "100%", border: "none", background: "#f6f6f7" }}
      allow="clipboard-write"
    />
  );
}
